import React, { Fragment, useState } from 'react';
import './style.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import HeaderLanguageSwitcher from '../../top/LanguageSwitcher/index.js';
import Button from '../../../../Shared/components/controls/Button/index.js';
import LoginLinks from '../../top/LoginLinks';

const AppHeaderMenuNavLinks = ({ items, languages, isEliteTheme }) => {
  const [isLoginActive, setLoginActive] = useState(false);
  const toggleLoginMenu = () => {
    setLoginActive(!isLoginActive);
    if (isLoginActive) {
      document.body.classList.remove('login-open');
    } else {
      document.body.classList.add('login-open');
    }
  };
  return (
    <div className="app-header-menu-nav-links">
      {items
        .filter(
          (item) =>
            (!!item.fields.link?.value?.href || item.fields.items?.length > 0) &&
            item.displayName !== 'Login'
        )
        .map((item, index) => {
          const needIcon = !!item?.fields?.linkIcon?.value?.src;
          const link = item?.fields?.link;
          const href = item?.fields?.link.value?.href;

          return (
            <Fragment key={index}>
              {href !== '' && href?.length > 8 && (
                <Button
                  variant="text"
                  color="secondary"
                  key={index}
                  link={link}
                  className="ah-mnl-link"
                  ignoreLinkClassName
                >
                  {needIcon && <Image field={item.fields.linkIcon} className="ah-mnl-link-icon" />}
                  <span className="ah-mnl-link-text">{link?.value?.text}</span>
                </Button>
              )}
              {(href === '' || href?.length <= 8) && (
                <Fragment>
                  <Button
                    variant="text"
                    color="secondary"
                    key={index}
                    className="ah-mnl-link"
                    ignoreLinkClassName
                    onClick={() => {
                      toggleLoginMenu();
                    }}
                  >
                    {needIcon && (
                      <Image field={item.fields.linkIcon} className="ah-mnl-link-icon" />
                    )}
                    <span className="ah-mnl-link-text">{link?.value?.text}</span>
                  </Button>
                  {item?.fields?.items?.length > 0 && (
                    <LoginLinks
                      item={item}
                      isLoginActive={isLoginActive}
                      toggleLoginMenu={toggleLoginMenu}
                    ></LoginLinks>
                  )}
                </Fragment>
              )}
            </Fragment>
          );
        })}

      <div className="ah-mnl-language-selector">
        <HeaderLanguageSwitcher languages={languages} isEliteTheme={isEliteTheme} />
      </div>
    </div>
  );
};

export default AppHeaderMenuNavLinks;
